// http/apiClient.ts
import axios from 'axios';
import getBearer from './getBearer';

// REACT_APP_ENV settes fra npm-scripts (start, start:demo, osv) ITS_AdminService.MultiTenancy.TenantResolverMiddleware: Information: TenantResolver: innkommende bruker. email=ove@ccsolution.no, phone=(null), oid=73483407-ce30-497e-8d2a-4b8bcb6310b2, iss=https://sts.windows.net/43831993-6193-4999-9fd2-50e9fa682c56/, tid=(null)
const env = process.env.REACT_APP_ENV ?? 'dev';

let baseURL: string;

if (env === 'demo') {
  // 🔹 Frontend mot Azure DEMO-backend
  baseURL = 'https://bluu-admin-api-demo.azurewebsites.net/api';
} else if (env === 'production') {
  // 🔹 Prod-backend (når dere vil bruke den)
  baseURL = 'https://bluu-admin-api-demo.azurewebsites.net/api';
  // baseURL = 'https://bluu-admin-api-prod.azurewebsites.net/api';
} else {
  // 🔹 DEV: frontend + backend lokalt
  baseURL = 'https://localhost:44387/api';
}

console.log('[API] baseURL =', baseURL);

export const api = axios.create({
  baseURL,
});

// 🔹 Alltid token + tenant på alle kall
api.interceptors.request.use(async (config) => {
  const token = await getBearer();
  if (token) {
    config.headers = config.headers ?? {};
    // getBearer() returnerer KUN accessToken → vi legger på "Bearer "
    config.headers.Authorization = `Bearer ${token}`;
  }

  const tenantId = localStorage.getItem('tenantId');
  if (tenantId) {
    config.headers = config.headers ?? {};
    config.headers['X-Tenant-Id'] = tenantId;
  }

  return config;
});
